import React from 'react';
import useSearchParams from '../../../../../useSearchParams';

interface Props {
  index: number;
}

const Close = ({index}: Props) => {
  const {query, setQuery} = useSearchParams();
  return (
    <div
      className="flex items-center"
      onClick={() => {
        setQuery({
          ...query,
          salesforceLeadSearchConditions: [
            ...query.salesforceLeadSearchConditions.slice(0, index),
            ...query.salesforceLeadSearchConditions.slice(index + 1),
          ],
        });
      }}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.5 9.5L9.5 2.5M2.5 2.5L9.5 9.5L2.5 2.5Z"
          stroke="var(--text-color-3)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Close;
